import Vue from 'vue';
import Vuex from 'vuex';

import { vuex } from './store';
// import { store } from './store';
import * as i18n from './i18n';
import * as Idle from '@/common/idleguard';
import App from './App';
import Meta from 'vue-meta';
import router from './router';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import VModal from 'vue-js-modal';
import { VTooltip, VPopover, VClosePopover } from 'v-tooltip';
import VueShortkey from 'vue-shortkey';
import VueSignaturePad from 'vue-signature-pad';
import VueTouch from 'vue-touch';
import vuexI18n from 'vuex-i18n';
import { BootstrapVue, FormCheckboxPlugin, IconsPlugin } from 'bootstrap-vue';
import VueClickOutsideElement from 'vue-click-outside-element';
// Had to import it globally. Otherwise styles are not included.
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

// Add site wide css classes (to simplify ui css over time)
import '@/styles/bootstrap4-utility.css';

// Global components
import Debug from '@/components/toolbar/Debug.vue';

Vue.component('debug', Debug);

Vue.use(Meta);
Vue.use(Vuex);
Vue.use(VModal);
Vue.use(VueShortkey, { prevent: ['input', 'textarea'] });
Vue.use(VueToast, { position: 'top', duration: 7000 });
Vue.use(VueSignaturePad);
Vue.use(BootstrapVue);
Vue.use(FormCheckboxPlugin);
Vue.use(IconsPlugin);
Vue.use(VueClickOutsideElement);

Vue.directive('tooltip', VTooltip);
Vue.directive('close-popover', VClosePopover);

Vue.component('phone-number-input', VuePhoneNumberInput);
Vue.component('v-popover', VPopover);

const store = new Vuex.Store(vuex);
Vue.use(vuexI18n.plugin, store);

Vue.use(VueTouch, { name: 'v-touch' });

Vue.config.performance = true;
Vue.config.productionTip = false;
Vue.config.debug = process.env.NODE_ENV !== 'production';

i18n.init(store);
Idle.init(store);

/* eslint-disable no-new */
var vue = new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
});

if (process.env.NODE_ENV !== 'production') {
  window._vue = vue;
}



// WEBPACK FOOTER //
// ./src/main.js